import { colorToHex } from '../../data'

const Leaf = ({ color = 'orange', size = 31 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.34397 8.0964C1.8892 10.5524 0.507055 13.8813 0.500027 17.3544C0.492999 20.8275 1.86166 24.1619 4.30647 26.6279C7.0627 20.2506 11.9752 14.9238 18.1064 11.7539C12.8143 16.2333 9.24203 22.4125 8.00019 29.235C12.8751 31.5421 18.8751 30.698 22.9063 26.6654C29.4313 20.1381 30.5 0.5 30.5 0.5C30.5 0.5 10.8689 1.56912 4.34397 8.0964Z"
        fill={colorToHex(color)}
      />
    </svg>
  )
}

export default Leaf
